import Backdrop from "../../../../../../Components/UI/Backdrop/Backdrop";
import LlmConfigFields from "../../LLM/LlmConfigFields";

// Same form as the LLM settings page. The Status toggle, Test Connection and Save live
// in PhishboxSettings' shared header and actions; it is saved into the phishbox config
// (custom_llm).
const LLM = ({ configs, onCustomLlmChange, onCustomLlmProviderChange, hasStoredKey }) => {
  return (
    <div className="phishbox-settings__llm">
      <LlmConfigFields
        configs={configs.custom_llm}
        onChange={onCustomLlmChange}
        onProviderChange={onCustomLlmProviderChange}
        hasStoredKey={hasStoredKey}
      />
      <Backdrop
        spinner={false}
        absolute
        show={!configs.custom_llm.active}
        message="LLM settings are inactive! Turn on the Status toggle above to activate them."
        messageStyle={{ paddingTop: 0 }}
      />
    </div>
  );
};

export default LLM;
